import { useEffect, useState } from "react";

import "../css/PopupInvoicePrinting.css";

import ButtonIconH from "../../components/ButtonIconH";
import CheckBox from "../../components/CheckBox";
import LoadingScreen from "../../components/LoadingScreen";
import { post } from "../js/api";
import { userData, selectedOptic } from "../../js/utils";
import { openDataUriInNewTab } from "./PopupInvoicePrinting";

export const generateDocument = async ({
  endpoint,
  params = {},
  printObservations = false,
  errorMessage = "Error al generar el documento.",
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const response = await post(endpoint, {
    token: userData.token,
    idOptica: selectedOptic.id,
    ...params,
    imprimirObservaciones: printObservations,
  });

  if (!response || response.error || !response.fichero) {
    createPopupQuestion(
      response?.error || errorMessage,
      removePopupQuestion,
      null,
      "Cerrar",
    );
    return null;
  }

  return response;
};

export default ({
  show,
  title = "Imprimir",
  endpoint,
  params = {},
  errorMessage = "Error al generar el documento.",
  onPrint,
  onClose,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const [printObservations, setPrintObservations] = useState(false);
  const [printing, setPrinting] = useState(false);

  useEffect(() => {
    if (show) {
      setPrintObservations(false);
    }
  }, [show]);

  const printDefault = async () => {
    const response = await generateDocument({
      endpoint,
      params,
      printObservations,
      errorMessage,
      createPopupQuestion,
      removePopupQuestion,
    });

    if (!response) return false;

    await openDataUriInNewTab(response.fichero, response.nombreFichero);
    return true;
  };

  const printInvoice = async () => {
    setPrinting(true);
    const success = onPrint
      ? await onPrint({ printObservations })
      : await printDefault();
    setPrinting(false);

    if (success) {
      onClose();
    }
  };

  return (
    show && (
      <div className="popup-container popup-normal popup-invoice-printing">
        <div className="popup-message">
          <div className="popup-header">
            <div className="popup-title">{title}</div>
            <img
              src="/images/close-white.svg"
              loading="lazy"
              alt=""
              className="popup-close"
              onClick={onClose}
            />
          </div>
          <div className="popup-body">
            {printing && <LoadingScreen message="" />}
            <div className="popup-row">
              <div
                className="data-field c-pointer"
                onClick={() => setPrintObservations((prev) => !prev)}
              >
                <CheckBox active={printObservations} onClick={() => {}} />
                <span className="label">Imprimir observaciones</span>
              </div>
            </div>
          </div>
          <div className="popup-footer">
            <div className="popup-row-buttons">
              <ButtonIconH
                text="Imprimir"
                disabled={printing}
                onClick={printInvoice}
              />
            </div>
          </div>
        </div>
      </div>
    )
  );
};
